module.exports = __webpack_public_path__ + "img/logo_dark.91f9a3d0.svg";